module.exports = __webpack_public_path__ + "assets/normal/images/default-avatar-radiu.52d678f7.png";